import React, { useState, useEffect } from 'react';
import swal from "sweetalert";
import { BotonAddItem, BotonRemovePequeño } from '../../Plantillas/Botones';
import { notificarMsg, notificarError } from '../../Almacenes/AlmacenNotify';

export default function Form({ action, currentId, modelo, onCancel, onSaveSuccess }) {
  const [loading, setLoading] = useState(false);
  const [nombre, setNombre] = useState("");
  const [codigoBarra, setCodigoBarra] = useState("");
  const [tipoProducto, setTipoProducto] = useState("VENTANA");
  const [tipoGeometria, setTipoGeometria] = useState("recto");
  const [svgBase, setSvgBase] = useState("");
  const [variables, setVariables] = useState([]);
  const [fileName, setFileName] = useState("Elegir archivo...");

  const [variableSeleccionada, setVariableSeleccionada] = useState("");

  useEffect(() => {
    if (modelo) {
      setNombre(modelo.Nombre || "");
      setCodigoBarra(modelo.CodigoBarra || "");
      setTipoProducto(modelo.TipoProducto || "VENTANA");
      setTipoGeometria(modelo.TipoGeometria || "recto");
      setSvgBase(modelo.SvgBase || "");
      setFileName(modelo.SvgBase ? "Archivo guardado previamente" : "Elegir archivo...");

      try {
        if (modelo.VariablesConfig) {
          const parsed = typeof modelo.VariablesConfig === 'string' ? JSON.parse(modelo.VariablesConfig) : modelo.VariablesConfig;
          // Si el JSON viene en el formato [{"id":"W","nombre":"Ancho"}], lo mapeamos a clave y descripcion
          const mappedVars = parsed.map(v => ({
            clave: v.id || v.clave,
            descripcion: v.nombre || v.descripcion
          }));
          setVariables(mappedVars);
        }
      } catch (e) {
        console.error("Error parseando VariablesConfig", e);
      }
    }
  }, [modelo]);

  const onAddVariable = () => {
    if (variableSeleccionada) {
      const opciones = [
        { clave: "W", descripcion: "ANCHO" },
        { clave: "H", descripcion: "ALTO" }
      ];
      const opcion = opciones.find(o => o.clave === variableSeleccionada);
      if (opcion) {
        if (!variables.find(v => v.clave === opcion.clave)) {
          setVariables([...variables, { clave: opcion.clave, descripcion: opcion.descripcion }]);
        } else {
          alert("Esta variable ya ha sido añadida.");
        }
        setVariableSeleccionada("");
      }
    }
  }

  const onRemoveVariable = (index) => {
    setVariables(variables.filter((_, i) => i !== index));
  }

  const handleFileUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    if (file.type !== "image/svg+xml" && !file.name.toLowerCase().endsWith('.svg')) {
      alert("Por favor, suba un archivo válido con extensión .svg");
      return;
    }

    const reader = new FileReader();
    reader.onload = (event) => {
      setSvgBase(event.target.result);
      setFileName(file.name);
    };
    reader.readAsText(file);
  };

  const onSaveForm = async () => {
    if (!nombre) {
      notificarError("El nombre del modelo es requerido");
      return;
    }
    if (!svgBase) {
      notificarError("Debe cargar un diseño SVG");
      return;
    }
    if (variables.length === 0) {
      notificarError("Debe configurar al menos una variable (ej. W o H)");
      return;
    }
    
    setLoading(true);
    try {
      const payload = {
        Nombre: nombre,
        CodigoBarra: codigoBarra,
        TipoProducto: tipoProducto,
        TipoGeometria: tipoGeometria,
        SvgBase: svgBase,
        VariablesConfig: variables
      };

      const method = currentId ? 'PATCH' : 'POST';
      const url = currentId ? `/api/vidrieria/modelos/${currentId}` : `/api/vidrieria/modelos`;

      const response = await fetch(url, {
        method,
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify(payload)
      });

      if (!response.ok) throw new Error("Error al guardar");

      notificarMsg("Modelo guardado correctamente");
      if (onSaveSuccess) onSaveSuccess();
    } catch (error) {
      console.error(error);
      notificarError("Ocurrió un error al guardar el modelo.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container-fluid" style={{ maxWidth: '1200px', margin: '0 auto' }}>
      <div className="row">

        {/* Columna Izquierda: Formulario */}
        <div className="col-12 col-md-6">
          <div className="row">
            <div className="col-12 mt-2">
              <div className="form-group">
                <label>Nombre del Modelo:</label>
                <input
                  className="form-control"
                  type="text"
                  value={nombre}
                  onChange={e => setNombre(e.target.value.toUpperCase())}
                  placeholder="Ej. VENTANA CORREDIZA"
                />
              </div>
            </div>

            <div className="col-12 mt-2">
              <div className="form-group">
                <label>Código de Barras (Opcional):</label>
                <input
                  className="form-control"
                  type="text"
                  value={codigoBarra}
                  onChange={e => setCodigoBarra(e.target.value)}
                />
              </div>
            </div>

            <div className="col-12 mt-2">
              <div className="form-group">
                <label>Tipo de Producto:</label>
                <select className="form-control" value={tipoProducto} onChange={e => setTipoProducto(e.target.value)}>
                  <option value="VENTANA">VENTANA</option>
                  <option value="MAMPARA">MAMPARA</option>
                </select>
              </div>
            </div>

            <div className="col-12 mt-2">
              <div className="form-group">
                <label>Tipo de Geometría:</label>
                <select className="form-control" value={tipoGeometria} onChange={e => setTipoGeometria(e.target.value)}>
                  <option value="recto">Recto</option>
                  <option value="curvo">Curvo</option>
                  <option value="especial">Especial</option>
                </select>
              </div>
            </div>

            <div className="col-12 mt-3">
              <h5>Configuración de Variables (Parámetros base)</h5>
              <div className="d-flex mb-2" style={{ gap: '10px' }}>
                <select
                  className="form-control form-control-sm"
                  style={{ width: '250px' }}
                  value={variableSeleccionada}
                  onChange={e => setVariableSeleccionada(e.target.value)}
                >
                  <option value="">Seleccione una variable...</option>
                  <option value="W">ANCHO (W)</option>
                  <option value="H">ALTO (H)</option>
                </select>
                <BotonAddItem type="button" onClick={onAddVariable} title="Añadir Variable" />
              </div>

              <table className="table table-sm table-bordered mt-2">
                <thead style={{ backgroundColor: "#f8f9fa" }}>
                  <tr>
                    <th>Clave</th>
                    <th>Descripción</th>
                    <th style={{ width: '50px' }}></th>
                  </tr>
                </thead>
                <tbody>
                  {variables.map((v, i) => (
                    <tr key={i}>
                      <td className="font-weight-bold">[{v.clave}]</td>
                      <td>{v.descripcion}</td>
                      <td align="center">
                        <BotonRemovePequeño type="button" onClick={() => onRemoveVariable(i)} title="Quitar" />
                      </td>
                    </tr>
                  ))}
                  {variables.length === 0 && <tr><td colSpan="3" className="text-center">No hay variables definidas</td></tr>}
                </tbody>
              </table>
            </div>

            <div className="col-12 mt-3">
              <div className="form-group">
                <label>Diseño SVG (Subir archivo .svg):</label>
                <div className="custom-file mb-2">
                  <input 
                    type="file" 
                    className="custom-file-input" 
                    id="customFileSvg" 
                    accept=".svg" 
                    onChange={handleFileUpload}
                  />
                  <label className="custom-file-label" htmlFor="customFileSvg" style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                    {fileName}
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Columna Derecha: Previsualización SVG */}
        <div className="col-12 col-md-6 mt-2">
          <div className="card h-100 shadow-sm border-0">
            <div className="card-header bg-white font-weight-bold text-center border-bottom-0 pt-4">
              Vista Previa SVG
            </div>
            <div className="card-body d-flex align-items-center justify-content-center" style={{ overflow: 'hidden' }}>
              <div
                style={{
                  transform: 'scale(0.50)', // Reducimos el tamaño al 50%
                  transformOrigin: 'center center',
                  maxWidth: '100%',
                  maxHeight: '100%'
                }}
                dangerouslySetInnerHTML={{ __html: svgBase || "<span class='text-muted'>Sin diseño SVG</span>" }}
              />
            </div>
          </div>
        </div>

        {/* Footer: Botones de Acción */}
        <div className="col-12 mt-4 pt-3 border-top d-flex justify-content-end">
          <button type="button" className="btn btn-secondary mr-2" onClick={onCancel} disabled={loading}>Cancelar</button>
          <button type="button" className="btn btn-info" onClick={onSaveForm} disabled={loading}>
            {loading ? "Guardando..." : "Guardar Modelo"}
          </button>
        </div>

      </div>
    </div>
  );
}
